import nookies from 'nookies_MUST_REMOVE_THIS_PACKAGE';

import {
  defaultOptions,
  getCookieNameByPrefix,
  getCookieNameByPrefixAndSuffix,
} from './cookie-helpers';
import type {
  CookieParseOptionsForNookies,
  CookieValue,
  CtxWithNextRequest,
  RequestCtx,
} from './types';

export type GetCookieOptions = {
  ctx?: CtxWithNextRequest;
  cookieOptions?: CookieParseOptionsForNookies;
  suffix?: string;
};

export const getCookie = (
  cookieName: string,
  { ctx, cookieOptions = defaultOptions, suffix }: GetCookieOptions = {}
): CookieValue => {
  const cookies = nookies.get(ctx as RequestCtx, cookieOptions);

  const foundCookieName = suffix
    ? getCookieNameByPrefixAndSuffix(cookies, cookieName, suffix)
    : getCookieNameByPrefix(cookies, cookieName);

  return foundCookieName && cookies[foundCookieName];
};
